<style lang="scss" scoped>
  @import "../../../../assets/scss/mixins";

  $leftWidth: 220px;

  .el-form .el-checkbox__label {
    font-size: 12px;
    padding-left: 5px;
  }

  .el-form .el-checkbox__inner {
    width: 14px;
    height: 14px;
  }

  .content-part {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;

    .content-left {
      width: $leftWidth;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      text-align: left;
      background-color: #eef2f3;

      > ul {
        margin: 0;
      }

      > h2 {
        padding: 0;
        margin: 0;
        font-size: 18px;
        font-weight: bold;
        line-height: 55px;
        border-bottom: 1px solid #ddd;
        background-color: #eef2f3;
      }

      .list-style {
        cursor: pointer;
        padding: 10px;
        text-align: center;

        span {
          display: inline-block;
          padding: 8px 35px;
        }

        &.active {
          span {
            background-color: $activeColor;
            border-radius: 20px;
            color: $activeColorFont
          }
        }

        &:hover {
          background: #dee9eb
        }

      }

    }

    .content-right {
      > h3 {
        padding: 0;
        margin: 0 0 20px;
        font-size: 18px;
        font-weight: normal;
        line-height: 55px;
        height: 55px;
        border-bottom: 1px solid #ddd;
        text-align: center;
        position: fixed;
        top: 0;
        right: 0;
        left: $leftWidth;
        background: #fff;
        z-index: 2;
      }

      position: absolute;
      top: 0;
      left: $leftWidth;
      right: 0;
      bottom: 0;
      overflow: auto;
      .hide-content {
        display: block;
      }
      .show-content {
      display: block;
      }
    }

    .min-gutter {
      .el-form-item {
        margin-bottom: 5px;

        .el-form-item__content {
          line-height: 20px;
          position: relative;
          font-size: 14px;
        }

        .el-form-item__label {
          text-align: right;
          vertical-align: middle;
          float: left;
          font-size: 14px;
          color: #606266;
          line-height: 20px;
          padding: 0 12px 0 0;
          box-sizing: border-box;
        }

      }

      .el-form-item__label {
        font-size: 12px
      }
    }

    .qp-box {
      margin-bottom: 5px;
      padding: 4px;
      box-shadow: 0 2px 1px 0 #ddd;
    }
  }

  .el-form .el-select {
    display: block;
  }

  .el-form .el-date-editor {
    display: block;
  }

  .el-form {
    border: 1px solid #eef2f3;
    margin: 15px 10px;
    border-radius: 4px;
    position: relative;
    padding-top: 10px;

    &.active {
      border-color: $activeColor;

      .title-link {
        color: $activeColor;
      }
    }
  }

  .title-link {
    position: absolute;
    top: -10px;
    left: 5px;
    padding: 0;
  }

  .btn-submit-save {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    text-align: center;
    padding: 15px;
  }

</style>


<template>
  <div>
    <div class="content-part">
      <div class="content-left">
        <h2 class="clearfix right-title">货品管理</h2>
        <ul>
          <li class="list-style" v-for="item in goodsMenu" @click="setIndexValue(item.key)"
              :class="{ 'active' : index==item.key}">
            <span class="a-link">{{ item.name }}</span>
          </li>
          <div class="btn-submit-save">

            <perm label="mdm-goods-edit">
              <div style="margin-bottom: 10px" v-if="form.state==='0'">
                <el-button style="width: 100px" :plain="true" type="danger" @click.prevent.stop="forbid"
                > 停用
                </el-button>
              </div>
              <div style="margin-bottom: 10px" v-if="form.state==='1'">
                <el-button style="width: 100px" :plain="true" type="success" @click.prevent.stop="enableGoods"
                >启用
                </el-button>
              </div>
            </perm>
            <perm :label="'code-goods-autonomously-audit'" v-if="checkOrgId&&form.auditedStatus==='0'">
              <div style="margin-bottom: 10px">
                <el-button style="width: 100px" :plain="true" type="warning" @click.prevent.stop="audited()">审核通过
                </el-button>
              </div>
            </perm>
            <perm :label="'code-goods-autonomously-reject-audit'" v-if="checkOrgId&&form.auditedStatus==='0'">
              <div style="margin-bottom: 10px">
                <el-button style="width: 100px" :plain="true" type="warning" @click.prevent.stop="notAudited()">
                  审核不通过
                </el-button>
              </div>
            </perm>
            <div>
              <el-button style="width: 100px" @click.prevent.stop="doClose">关闭</el-button>
            </div>
          </div>

        </ul>
      </div>
      <div class="content-right min-gutter" @scroll="setCurrentTab">
        <h3>{{currentPartName}}</h3>
        <el-form id="0" class="form-part goods-form-info" :class="{active: index === 0}" ref="baseForm"
                 :model="form"
                 label-width="160px"
                 style="padding-right: 20px;">
          <h2 class="title-link">基础信息设置</h2>
          <div class="hide-content">
            <div style="margin-left: 20px;margin-top: 20px">

              <perm :label="xmlBtnList[5].perm">
                <div class="mb-10" v-if="form.typeId === '1'">
                  <el-button @click="xmlBtnList[5].click(form.id)" type="primary">{{xmlBtnList[5].label}}</el-button>
                </div>
              </perm>

              <perm :label="xmlBtnList[6].perm">
                <div class="mb-10" v-if="form.typeId === '2'">
                  <el-button @click="xmlBtnList[6].click(form.id)" type="primary">{{xmlBtnList[6].label}}</el-button>
                </div>
              </perm>

            </div>

            <el-form-item label="审核不通过原因:" v-if="form.auditedStatus && form.rejectReason">
              <span style="color: red">{{form.rejectReason}}</span>
            </el-form-item>
            <el-form-item label="货品ID:">
              {{form.id}}
            </el-form-item>
            <el-form-item label="货品种类:">
              <dict :dict-group="'goodsKind'" :dict-key="form.goodsKind"></dict>
            </el-form-item>
            <el-form-item label="货品分类:">
              {{formatGoodsTypeList(form.typeId)}}
            </el-form-item>
            <el-form-item label="货品编号:">
              {{form.code}}
            </el-form-item>
            <el-form-item label="厂商货品编码:">
              {{form.factoryGoodsCode}}
            </el-form-item>
            <el-form-item label="所属经营范围:">
              <dict :dict-group="'scopes'" :dict-key="form.businessScope"></dict>
            </el-form-item>


            <el-form-item label="国家药品标识码:">
              {{form.nationGoodsIdentificationCode}}
            </el-form-item>
            <el-form-item label="药品本位码:">
              {{form.goodsStandardCode}}
            </el-form-item>
            <el-form-item label="通用名称:">
              {{form.name}}
            </el-form-item>

            <el-form-item label="通用名称拼音:" class="R">
              {{form.namePhonetic}}
            </el-form-item>
            <el-form-item label="通用名称拼音首字母:" class="R">
              {{form.nameAcronymy}}
            </el-form-item>

            <el-form-item label="英文名称:">
              {{form.goodsEnglishName}}
            </el-form-item>
            <el-form-item label="商品名称:">
              {{form.genericName}}
            </el-form-item>
            <el-form-item label="剂型:">
              <dict :dict-group="'dosageForm'" :dict-key="form.dosageForm"></dict>
            </el-form-item>
            <el-form-item label="注册分类:">
              <dict :dict-group="'drugsRegisterType'" :dict-key="form.drugsRegisterType"></dict>
            </el-form-item>
            <el-form-item label="规格/型号:">
              {{form.specifications}}
            </el-form-item>
            <el-form-item label="规格/型号简称:">
              {{form.specificationAbbreviation}}
            </el-form-item>
            <el-form-item label="有效期:">
              {{ form.expiryNumber }} {{ form.expiryUnit | formExpiryUnit}}
            </el-form-item>
            <el-form-item label="批准文号:">
              {{form.approvalNumber}}
            </el-form-item>
            <el-form-item label="批准文号有效期:">
              {{ form.goodsApprovalNOValidity | date }}
            </el-form-item>
            <el-form-item label="批准文号批准日期:">
              {{ form.goodsApprovalNumberApprovalDate | date }}
            </el-form-item>
            <el-form-item label="包装规格:">
              {{form.packingSpecification}}
            </el-form-item>
            <el-form-item label="包装规格简称:">
              {{form.packingSpecificationsAbbreviation}}
            </el-form-item>
            <el-form-item label="包装转换比:">
              {{form.packingConversionRatio}}
            </el-form-item>
            <el-form-item label="包装转换比单位:">
              <dict :dict-group="'measurementUnit'" :dict-key="form.packingConversionRatioUnit"></dict>
            </el-form-item>

            <el-form-item label="最小赋码包装单位:">
              {{form.minPackageUnit}}
            </el-form-item>
            <el-form-item label="最小赋码单位所含最小计价单位数量:">
              {{form.minTagUnitCount}}
            </el-form-item>
            <el-form-item label="最小计价单位:">
              <dict :dict-group="'measurementUnit'" :dict-key="form.measurementUnit"></dict>
            </el-form-item>
            <el-form-item label="生产企业名称:">
              {{ form.factoryName }}
            </el-form-item>
            <el-form-item label="统一社会信用代码（生产企业）:">
              {{ form.factoryCreditCode }}
            </el-form-item>

            <el-form-item label="上市许可持有人名称:">
              {{ form.vaccineMarketingApprovalPossessorName }}
            </el-form-item>

            <el-form-item label="统一社会信用代码（上市许可持有人）:">
              {{ form.creditCodePossessor }}
            </el-form-item>


            <el-form-item label="证件类型:">
              <dict :dict-group="'certificateType'" :dict-key="form.certificateType"></dict>
            </el-form-item>

            <el-form-item label="证件号（上市许可持有人）:">
              {{ form.certificateNo }}
            </el-form-item>

            <el-form-item label="货品来源:">
              <dict :dict-group="'importation'" :dict-key="form.importation"></dict>
            </el-form-item>
            <el-form-item label="国家或地区:">
              {{ form.origin }}
            </el-form-item>
            <el-form-item label="进口注册证号:">
              {{form.registrationNumber}}
            </el-form-item>
            <el-form-item label="进口注册证有效期:">
              {{ form.registrationNOValidity | date }}
            </el-form-item>
            <el-form-item label="进口注册证批准日期:">
              {{ form.importGoodsApprovalDate | date }}
            </el-form-item>
            <el-form-item label="进口批件号:">
              {{ form.importGoodsInstructionsNumber }}
            </el-form-item>
            <el-form-item label="进口批件有效期:">
              {{ form.importGoodsInstructionsDate | date }}
            </el-form-item>

            <el-form-item label="公司名称（中文）:">
              {{ form.companyChineseName }}
            </el-form-item>
            <el-form-item label="公司地址（中文）:">
              {{ form.companyChineseAddress}}
            </el-form-item>
            <el-form-item label="公司地址（英文）:">
              {{ form.companyEnglishAddress}}
            </el-form-item>

            <el-form-item label="公司所在国家或地区（英文）:">
              {{ form.companyEnglishLocation}}
            </el-form-item>

            <el-form-item label="产品图片:">
              <div :class="{'base-pic-item':form.photo,'base-pic-item-normal':!form.photo} "
                   @click="handlePreview(form.photoId)">
                <compressed-img v-if="form.photo"
                                :src="form.photo?form.photo+'?image&action=resize:w_380,m_0':'/static/img/userpic.png' "/>
                <img src="/static/img/userpic.png" v-else>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <el-form id="1" class="form-part goods-form-info" :class="{active: index === 1}" ref="storeForm"
                 :model="form" label-width="160px" style="padding-right: 20px">
          <h2 class="title-link">存储信息设置</h2>
          <div class="hide-content">
            <el-form-item label="储存条件:">
              <dict :dict-group="'storageCondition'" :dict-key="form.storageConditionId"></dict>
            </el-form-item>
            <el-form-item label="运输温度范围:">
              <span
                v-show="form.transportStartTemperature">{{ form.transportStartTemperature}} ℃ - {{ form.transportEndTemperature}} ℃</span>
            </el-form-item>
            <el-form-item label="存储温度范围:">
              <span
                v-show="form.storageStartTemperature">{{ form.storageStartTemperature}} ℃ - {{ form.storageEndTemperature}} ℃</span>
            </el-form-item>
          </div>
        </el-form>
        <el-form id="2" class="form-part goods-form-info" :class="{active: index === 3}" ref="managerForm"
                 :model="form" label-width="180px" style="padding-right: 20px" v-show="goodsType < 4">
          <h2 class="title-link">管理控制</h2>
          <div class="hide-content">
            <el-form-item label="商品追溯码编号:">
              {{form.goodsTrackNo}}
            </el-form-item>
          </div>
        </el-form>
        <el-form id="3" class="form-part goods-form-info" :class="{active: index === 4}" ref="dcForm"
                 :model="form" v-show="form.typeId && goodsType < 4"
                 label-width="180px" style="padding-right: 20px">
          <h2 class="title-link" v-if="form.propertyMap">{{showTitle}}专用</h2>
          <div class="hide-content" v-if="form.propertyMap">
            <div v-if="goodsType===1">
              <el-form-item label="是否国家免疫规划疫苗:">
                {{form.propertyMap.nationImmuneProjectVaccineFlag | formatStatus}}
              </el-form-item>
              <el-form-item label="药物使用次剂量:">
                {{form.propertyMap.goodsUsedDosage}}
              </el-form-item>
              <el-form-item label="药物使用剂量单位:">
                {{form.propertyMap.goodsUsedDosageUnit}}
              </el-form-item>
              <el-form-item label="最小销售包装单元可用人份数:">
                {{form.propertyMap.personPortion}}
              </el-form-item>
            </div>

            <div v-else-if="goodsType===2">
              <el-form-item label="国家基本药物标识:">
                {{form.propertyMap.nationBasicDrugsSign | formatThreeStatus}}
              </el-form-item>
              <el-form-item label="处方药标识:">
                {{form.propertyMap.goodsOtc | formatThreeStatus}}
              </el-form-item>
              <el-form-item label="特殊药品管理分类:">
                <dict :dict-group="'specialDrugsType'" :dict-key="form.propertyMap.specialDrugsFlag"></dict>
              </el-form-item>
              <el-form-item label="蛋白同化制剂标志:">
                {{form.propertyMap.anabolicAgentsSign | formatThreeStatus}}
              </el-form-item>
              <el-form-item label="运动员慎用:">
                {{form.propertyMap.athletesCaution | formatThreeStatus}}
              </el-form-item>
              <el-form-item label="肽类激素制剂标志:">
                {{form.propertyMap.peptideHormoneFlag | formatThreeStatus}}
              </el-form-item>
              <el-form-item label="含特殊药品复方制剂标志:">
                {{form.propertyMap.specialDrugCompoundPreparation | formatThreeStatus}}
              </el-form-item>

            </div>
            <div v-else-if="goodsType===3">
              <el-form-item label="注册证号/备案凭证号:" prop="propertyMap.registrationRecordNumber">
                {{form.propertyMap.registrationRecordNumber}}
              </el-form-item>
              <el-form-item label="注册证号/备案凭证号有效期:" prop="propertyMap.goodsRecordNOValidity">
                {{form.propertyMap.goodsRecordNOValidity | date}}
              </el-form-item>
              <el-form-item label="防震荡标志:">
                {{form.propertyMap.antiShockFlag | formatThreeStatus}}
              </el-form-item>
              <el-form-item label="防倾斜标志:">
                {{form.propertyMap.antiTiltFlag | formatThreeStatus}}
              </el-form-item>
            </div>
          </div>
        </el-form>
        <el-form id="4" class="form-part goods-form-info" :class="{active: index === 5}" ref="attachmentForm"
                 :model="form" label-width="160px" v-show="goodsType < 4"
                 style="padding-right: 20px">
          <h2 class="title-link">附件上传</h2>
          <div class="hide-content">
            <el-row>
              <el-row style="border-bottom: 1px solid #eee" v-for="item in attachmentTypeList"
                      :key="item.objectType" v-show="showField(item.showType) && item.attachmentIdList.length">
                <h2 class="h2-title">
                  <div class="left-title">{{item.name}}</div>
                </h2>
                <div style="margin-left: 20px">
                  <attachment-lists :attachmentIdList="item.attachmentIdList" :objectId="form.id"
                                    :objectType="item.objectType" :permission="'show'"/>
                </div>
              </el-row>
            </el-row>
          </div>
        </el-form>
<!--        <el-form id="5" class="form-part goods-form-info" :class="{active: index === 6}" ref="updateLogForm"-->
<!--                 :model="form"-->
<!--                 label-width="160px"-->
<!--                 style="padding-right: 20px">-->
<!--          <h2 class="title-link" style="z-index: 100">修改记录</h2>-->
<!--          <div class="hide-content">-->
<!--            <el-form-item label="创建时间:" v-if="form.createTime" style="position:relative; left:-15%">-->
<!--              {{form.createTime|time}}-->
<!--            </el-form-item>-->
<!--            <el-table :data="pojoLogList" style="width: 100%" class="table-edit">-->
<!--              <el-table-column label="修改人" prop="pojoModifyInfoCommitterId">-->
<!--              </el-table-column>-->
<!--              <el-table-column label="修改时间" prop="pojoModifyInfoCreateTime">-->
<!--                <template slot-scope="props">-->
<!--                  {{props.row.pojoModifyInfoCreateTime | time}}-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--              <el-table-column type="expand">-->
<!--                <template slot-scope="props">-->
<!--                  <el-form inline class="demo-table-expand">-->
<!--                    <el-table :data="props.row.list" border style="width: 100%">-->
<!--                      <el-table-column prop="pojoModifyDetailChineseName" label="字段名">-->
<!--                      </el-table-column>-->
<!--                      <el-table-column prop="pojoModifyDetailNew" label="新值">-->
<!--                      </el-table-column>-->
<!--                      <el-table-column prop="pojoModifyDetailOld" label="旧值">-->
<!--                      </el-table-column>-->
<!--                    </el-table>-->
<!--                  </el-form>-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--            </el-table>-->
<!--          </div>-->
<!--        </el-form>-->
      </div>
    </div>
  </div>
</template>

<script>
  import {Goods, pojoLog} from '../../../../resources';
  import utils from '../../../../tools/utils';
  import omsUploadPicture from '../../../common/upload/upload.picture.vue';
  import attachmentLists from '../../../common/attachmentList.vue';

  export default {
    components: {
      omsUploadPicture, attachmentLists
    },
    name: 'showForm',
    props: {
      formItem: {
        type: Object,
        default: {},
        required: true
      },
      title: {
        type: String,
        default: '增加'
      },
      action: {
        type: String,
        default: ''
      },
      actionType: {
        type: Boolean,
        default: true
      },
      getDefaultForm: Function
    },
    data: function () {
      return {
        attachmentIdList: [],
        form: this.formItem,
        attachmentRules: {},
        updateLogForm: {},
        pojoLogList: [],
        currentPartName: '',
        index: 0,
        doing: false,
        photo: {},
        validFlag: false,
        saveKey: 'productForm',
        formData: {},
        title_ele: [],
        titleOffsetTop: [],
        pushFlag: false,
        attachmentTypeList: []
      };
    },
    computed: {
      checkOrgId(){
        if (!this.form.factoryId)return false;
        return this.form.factoryId===this.$store.state.user.userCompanyAddress;
      },
      goodsType() {
        let typeId = this.form.typeId;
        if (!typeId) return -1;
        if (typeId <= 2) {
          return 1;
        } else if (typeId <= 6) {
          return 2;
        } else if (typeId <= 8) {
          return 3;
        } else {
          return 4;
        }
      },
      showTitle: function () {
        switch (this.goodsType) {
          case 1:
            return '疫苗';
          case 2:
            return '药品';
          case 3:
            return '器械';
          case 4:
            return '其他';
          default:
            return '';
        }
      },
      certificateType() {
        return this.$getDict('certificateType');
      },
      goodsMenu() {
        if (!this.form.typeId) return [{name: '基础信息设置', key: 0, checked: false}];
        let ary = [
          {name: '基础信息设置', key: 0, checked: false},
          {name: '存储信息设置', key: 1, checked: false}
        ];
        if (this.goodsType > 0 && this.goodsType < 4) {
          ary = ary.concat([
            {name: '管理控制', key: 2, checked: false},
            {name: `${this.showTitle}专用`, key: 3, checked: false},
            {name: '附件上传', key: 4, checked: true}
          ]);
        }
        return ary;
      }
    },
    watch: {
      formItem: function (val) {
        this.form.id = '';
        this.attachmentTypeList = JSON.parse(JSON.stringify(this.$store.state.attachmentTypeList));
        if (!this.actionType) return;
        if (val.id) {
          this.form = Object.assign({}, this.getDefaultForm(), JSON.parse(JSON.stringify(val)));
          this.photo = {};
          this.isNameDisabled = this.form.name !== '0';
          this.isDosageFormDisabled = this.form.dosageForm !== '0';
          this.idSpecificationsDisabled = this.form.specifications !== '0';
          this.isApprovalNumberDisabled = this.form.approvalNumber !== '0';
          this.isPackingSpecificationDisabled = this.form.packingSpecification !== '0';
          this.isMinTagUnitCountDisabled = this.form.minTagUnitCount !== 0;
          this.isOriginDisabled = this.form.origin !== '0';
          this.isRegistrationNumberDisabled = this.form.registrationNumber !== '0';
          this.attachmentTypeList.forEach(i => {
            i.attachmentList = this.form[i.type] || [];
            i.attachmentList.forEach(i => {
              i.name = i.attachmentFileName;
            });
            i.attachmentIdList = i.attachmentList.map(m => m.attachmentId);
          });
        }
        // this.getUpdateLogList();
        this.index = 0;
        let ele_warp = this.$el.getElementsByClassName('content-right')[0];
        ele_warp.scrollTop = 0;
      },
      index: function () {
        this.goodsMenu.forEach((item) => {
          if (item.key === this.index) {
            this.currentPartName = item.name;
          }
        });
      }
    },
    filters: {
      formExpiryUnit: function (value) {
        let array = {
          0: '年',
          1: '月',
          2: '日'
        };
        return array[value];
      },
      formatThreeStatus(val) {
        return val === null || val === undefined ? '待完善' : val === true ? '是' : '否';
      }
    },
    mounted: function () {
      this.currentPartName = this.goodsMenu[0] && this.goodsMenu[0].name || '';
      this.setChecked();
    },
    methods: {
      showField(arr) {
        return arr.some(a => (a + '') === this.form.typeId);
      },
      formatGoodsTypeList(val) {
        let goodsTypeList = this.$store.state.goodsTypeList;
        return goodsTypeList[val - 1] && goodsTypeList[val - 1].label || val;
      },
      setCurrentTab(e) {
        let event = e || window.event;
        let target = event.target || e.srcElement;
        !this.title_ele.length && (this.title_ele = target.getElementsByClassName('form-part'));
        if (!this.titleOffsetTop.length) {
          for (let i = 0; i < this.title_ele.length; i++) {
            this.titleOffsetTop.push(this.title_ele[i].offsetTop - 65);
          }
        }
        let scrollTop = target.scrollHeight - target.clientHeight;
        if (target.scrollTop === scrollTop) {
          return;
        }
        for (let i = 0; i < this.titleOffsetTop.length; i++) {
          if (target.scrollTop > this.titleOffsetTop[i] - 20) {
            this.index = i;
          }
        }
      },
      forbid: function () {// 禁用
        this.$confirm('确认禁用货品"' + this.form.name + '"?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let itemTemp = JSON.parse(JSON.stringify(this.form));
          itemTemp.state = '1';
          Goods.update(itemTemp.id, itemTemp).then(() => {
            this.$notify.success({
              title: '成功',
              message: '已经禁用货品"' + this.form.name + '"'
            });
            this.$emit('change', this.form);
            this.$emit('right-close');
          });
        });
      },
      audited: function () {
        this.$confirm('确认通过货品"' + this.form.name + '"的审核?', '', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          Goods.check(this.form.id, {auditedStatus: '1'}).then(() => {
            this.$notify.success({
              duration: 2000,
              title: '成功',
              message: '审核货品"' + this.form.name + '"成功'
            });
            this.$emit('change', this.form);
            this.$emit('right-close');
          }).catch(error => {
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '审核货品"' + this.form.name + '"失败'
            });
          });
        });
      },
      notAudited: function () {
        this.$prompt('', '审核不通过', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入审核不通过原因',
          inputValidator: val => {
            if (!val) return '请输入原因';
            return true;
          }
        }).then(({value}) => {
          Goods.check(this.form.id, {auditedStatus: '2', rejectReason: value}).then(() => {
//            this.getPageList();
            this.$notify.success({
              duration: 2000,
              title: '成功',
              message: '货品"' + this.form.name + '"审核未通过'
            });
            this.$emit('change', this.form);
            this.$emit('right-close');
          }).catch(error => {
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '货品"' + this.form.name + '"审核未通过失败'
            });
          });
        }).catch(() => {

        });
      },
      enableGoods: function () {
        this.$confirm('确认启用货品"' + this.form.name + '"?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let itemTemp = JSON.parse(JSON.stringify(this.form));
          itemTemp.state = '0';
          Goods.update(itemTemp.id, itemTemp).then(() => {
            this.$notify.success({
              title: '成功',
              message: '已成功启用"' + this.form.name + '"'
            });
            this.$emit('change', this.form);
            this.$emit('right-close');
          });
        });
      },
      handlePreview: function (id) {
        this.$store.commit('changeAttachment', id);
      },
      setChecked: function () {
        if (this.action === 'edit') {
          this.goodsMenu.forEach(val => {
            val.checked = true;
          });
        }
      },
      getUpdateLogList: function () {
        pojoLog.queryPojoLog(this.form.id, 'goods').then(res => {
          this.pojoLogList = res.data.list;
        });
      },
      setIndexValue: function (value) {
        this.index = value;
        let ele = document.getElementById(value);
        if (!ele) return;
        let ele_warp = this.$el.getElementsByClassName('content-right')[0];
        let scrollTop = ele_warp.scrollHeight - ele_warp.clientHeight;
        let otp = ele.offsetTop - 65;
        ele_warp && (ele_warp.scrollTop = scrollTop > otp ? otp : scrollTop);
      },
      doClose: function () {// 关闭弹窗,重置表单
        this.$emit('right-close');
      },
      changeBuyTime: function (date) {
        this.form.buyTime = this.$moment(date).format('YYYY-MM-DD');
      }
    }
  };
</script>

